import React, { useState } from 'react';
import { PrivateAxios } from '../../request/axios';
import Swal from 'sweetalert2';
import { FaKey } from 'react-icons/fa';

const ModifierMdpUser = () => {
    const [isLoading, setIsLoading] = useState(false);
    const styles = `
.btn-confirm {
    background-color: #00008F;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    margin: 2px;
}
.btn-confirm:hover {
    background-color: #0000A5;
}
.btn-cancel {
    background-color: #D24723;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    margin: 2px;
}
.btn-cancel:hover {
    background-color: #E25A3A;
}
`;

    // Ajouter le style dans le document
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);

    const handleChangePassword = () => {
        Swal.fire({
            title: '<h2 style="color:#00008F;">Changer le mot de passe</h2>', // Titre avec la couleur AXA Blue
            html: `
                <input type="password" id="newPassword" class="swal2-input" placeholder="Nouveau mot de passe">
                <input type="password" id="confirmPassword" class="swal2-input" placeholder="Confirmer le mot de passe">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Changer',
            cancelButtonText: 'Annuler',
            buttonsStyling: false, // Disable default styling to apply custom styles
            customClass: {
                confirmButton: 'btn-confirm',
                cancelButton: 'btn-cancel',
            },
            preConfirm: () => {
                const newPassword = Swal.getPopup().querySelector('#newPassword').value;
                const confirmPassword = Swal.getPopup().querySelector('#confirmPassword').value;

                if (!newPassword || !confirmPassword) {
                    Swal.showValidationMessage(`Veuillez remplir les deux champs`);
                    return false;
                }
                if (newPassword !== confirmPassword) {
                    Swal.showValidationMessage(`Les mots de passe ne correspondent pas`);
                    return false;
                }
                return { newPassword };
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const { newPassword } = result.value;
                setIsLoading(true);

                try {
                    const payload = { password: newPassword };
                    await PrivateAxios.put(`/user`, payload, {timeout: 0});
                    Swal.fire('Succès', 'Votre mot de passe a été changé', 'success');
                } catch (error) {
                    const message = error.response?.data?.message || error.message;
                    Swal.fire('Erreur', `Erreur lors du changement de mot de passe : ${message}`, 'error');
                } finally {
                    setIsLoading(false);
                }
            }
        });
    };

    return (
        <div className="flex justify-center">
            <button
                onClick={handleChangePassword}
                className="bg-axa-blue-400 text-white px-4 py-2 rounded-lg flex items-center hover:bg-hover-axa-blue transition duration-200"
                disabled={isLoading}
            >
                <FaKey className="mr-2" />
                {isLoading ? 'Chargement...' : 'Changer le mot de passe'}
            </button>
        </div>
    );
};

export default ModifierMdpUser;
